import { createAction, createSlice } from '@reduxjs/toolkit';

export const loginSuccess = createAction('AAD_LOGIN_SUCCESS');
export const loginFailed = createAction('AAD_LOGIN_FAILED');
export const logoutSuccess = createAction('AAD_LOGOUT_SUCCESS');
export const acquiredAccessTokenSuccess = createAction(
  'AAD_ACQUIRED_ACCESS_TOKEN_SUCCESS'
);
export const acquiredAccessTokenError = createAction(
  'AAD_ACQUIRED_ACCESS_TOKEN_ERROR'
);

export const acquiredEmployeeDetailsSuccess = createAction(
  'AAD_ACQUIRED_EMPLOYEE_DETAILS_SUCCESS'
);
export const setError = createAction('AAD_SET_ERRORS');
export const setIsLoading = createAction('AAD_INITIALIZING');
export const setInitialized = createAction('AAD_INITIALIZED');

export const initialState = {
  isLoading: false,
  errors: null,
  data: {}
};

const aad = (builder) => {
  builder
    .addCase(loginSuccess, (state, action) => {
      state.isLoading = initialState.isLoading;
      state.data = action.payload;
      state.errors = initialState.errors;
    })
    .addCase(logoutSuccess, () => initialState)
    .addCase(acquiredAccessTokenSuccess, (state, action) => {
      state.data.token = action.payload;
    })
    .addCase(acquiredEmployeeDetailsSuccess, (state, action) => {
      state.isLoading = initialState.isLoading;
      state.data.account = state.data.account || {};
      state.data.account = { ...state.data.account, ...action.payload };
      state.errors = initialState.errors;
    })
    .addCase(setError, (state, action) => {
      state.isLoading = initialState.isLoading;
      state.errors = action.payload;
    })
    .addCase(loginFailed, (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = [
        {
          code: 'LOGIN_FAILED',
          message: 'Login failed'
        }
      ];
      state.data = initialState.data;
    })
    .addCase(acquiredAccessTokenError, (state, action) => {
      const { errorCode, errorMessage, name } = action.payload;
      state.isLoading = initialState.isLoading;
      state.errors = [{ message: errorMessage, code: errorCode, name }];
    })
    .addCase(setIsLoading, (state) => {
      state.isLoading = true;
    })
    .addCase(setInitialized, (state) => {
      state.isLoading = initialState.isLoading;
    })
    .addDefaultCase((state) => state);
};

export const slice = createSlice({
  name: 'aad',
  initialState,
  extraReducers: aad
});

export const selectSlice = (state) => state.aad;
export const selectData = (state) => selectSlice(state).data;
export const selectAccessToken = (state) => {
  const data = selectData(state);

  if (!data.token) {
    return;
  }
  return data.token.accessToken;
};
export const selectAccount = (state) => selectData(state).account;
export const selectErrors = (state) => selectSlice(state).errors;
export const selectIsLoading = (state) => selectSlice(state).isLoading;

export default slice.reducer;
